module.exports = "https://deal-img.imgix.net/consumer/modern/apple-touch-icon.d485aa82.png";